import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Paper, Stack } from '../../atoms';
import { CardContent, List, ListItemButton, ListItemText, SummaryTable, Table, } from '../../legacy/components';
import { styled } from '../../legacy/utils';
export function NestedDataTable({ nestedData }) {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const handleListItemClick = (index) => {
        setSelectedIndex(index);
    };
    //Prep tabledata for "reverse" structure needed because of 2d array and requirement
    const columns = [
        {
            label: ' ',
            value: (row) => row.label,
        },
    ];
    const cellData = [];
    if (nestedData.length > 0 &&
        nestedData[selectedIndex].contents.length > 1 &&
        nestedData[selectedIndex].contents[0].length > 0) {
        for (let i = 0; i < nestedData[selectedIndex].contents.length; i++) {
            columns.push({
                label: String(i + 1),
                value: (row) => row.data[i],
            });
        }
        for (let i = 0; i < nestedData[selectedIndex].contents[0].length; i++) {
            const rowData = {
                label: nestedData[selectedIndex].contents[0][i].description,
                data: [],
            };
            for (let j = 0; j < nestedData[selectedIndex].contents.length; j++) {
                rowData.data.push(nestedData[selectedIndex].contents[j][i].value);
            }
            cellData.push(rowData);
        }
    }
    return (_jsxs(Stack, { flexDirection: { mobile: 'column', md: 'row' }, gap: 3, children: [_jsx(ListStyled, { children: nestedData.map((item, i) => (_jsx(ListItemButtonStyled, { selected: selectedIndex === i, onClick: () => handleListItemClick(i), children: _jsx(ListItemText, { primary: item.description }) }, i))) }), nestedData.length > 0 &&
                nestedData[selectedIndex].contents.length === 1 && (_jsx(Stack, { flex: "auto", children: _jsx(Paper, { children: _jsx(CardContent, { children: _jsx(SummaryTable, { striped: true, alignItems: "flex-start", rows: nestedData[selectedIndex].contents[0].map((item) => ({
                                label: item.description,
                                value: item.value?.toString(),
                            })), editable: false, columns: 3 }) }) }) })), nestedData.length > 0 &&
                nestedData[selectedIndex].contents.length > 1 && (_jsx(Stack, { flex: "auto", children: _jsx(Paper, { children: _jsx(CardContent, { children: _jsx(Table, { columns: columns, data: cellData, stripes: "odd", pagination: true, pageCount: cellData.length / 20, rowLimit: 20, alternativeCellAlignmentRight: true }) }) }) }))] }));
}
const ListItemButtonStyled = styled(ListItemButton)(({ theme }) => ({
    margin: 0,
    '&:hover': {
        backgroundColor: `${theme.palette.primary.lighter}0D`,
    },
    '&.Mui-selected': {
        backgroundColor: `${theme.palette.primary.lighter}0D`,
        '&::before': {
            width: '2px',
            backgroundColor: theme.palette.groupPrimary.zurichBlue,
        },
    },
}));
const ListStyled = styled(List)(({ theme }) => ({
    maxWidth: theme.spacing(30),
    border: `1px solid ${theme.palette.groupPrimary.lightDove}`,
    borderRadius: theme.spacing(1),
    height: '100%',
    backgroundColor: 'white',
    [theme.breakpoints.down('sm')]: {
        maxWidth: '100%',
    },
}));
